import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="48.25 23.33 48.25 48.36 26.57 48.45 15.8 33.5 39.68 14.24 48.25 23.33"
  />
);

export let NemoAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.nemo}
    renderShadow={renderShadow}
  >
    <>
      <path
        d="m13.1,28.47c-.43.7-.97,1.38-1.4,2.08-1.34-.19-1.98-2.18-1-3.11.76.5,1.51.84,2.4,1.03Z"
        style={{
          fill: '#d94726',
          stroke: '#d94726',
          strokeMiterlimit: 10,
          strokeWidth: 1.16,
        }}
      />
      <path
        d="m30.09,23.53c1.87,6.62-3.23,12.61-8.46,12.61s-9.8-5.63-8.05-12.28,4.16-10.06,8.05-10.06c5.23,0,6.51,2.8,8.46,9.74Z"
        style={{ fill: '#f0643a' }}
      />
      <path
        d="m32.93,16.25c1.09-.83,2.66-2.87,3.75-3.71.73-.57,1.86.18,2.5.86,1.1,1.17,1.44,2.33,1.5,3.94s-.36,3.21-1.06,4.66c-.05.1-.11.21-.21.24-.08.03-.17,0-.25-.03-.66-.22-1.27-.57-1.93-.78s-1.4-.29-2.03.02c-.36-2.12-1.16-3.36-2.28-5.2Z"
        style={{ fill: '#f0643a' }}
      />
      <path
        d="m23.5,17.23c2.08,1.43,5.84,1.61,9.15.42.12-.04.26-.1.33-.18.07-.08.07-.16.07-.24.02-.67.03-1.36-.24-1.95-.16-.35-.44-.68-.95-.79s-1.26.07-1.57.46c.06-.92-.16-1.79-.64-2.54-.1-.16-.22-.31-.43-.4-.45-.19-1.19,0-1.69.32s-.81.75-1.11,1.16c.01-1.04-.32-2.01-.95-2.83-.12-.15-.26-.31-.52-.36-.48-.09-1.06.26-1.49.57-1.51,1.08-3.18,2.41-3.02,3.67l3.06,2.7Z"
        style={{
          fill: '#f0643a',
          stroke: '#f0643a',
          strokeMiterlimit: 10,
          strokeWidth: 1.16,
        }}
      />
      <path
        d="m19.55,31.27c1.45.13,2.93-.23,4.16-1.01,0,.83-.56,1.55-1.21,2.06-.41.33-.91.6-1.43.57s-1.51-1.63-1.51-1.63Z"
        style={{ fill: '#b41f21' }}
      />
      <path
        d="m25.22,13.46c1.77.3,3.55.6,5.32.91.65.11,1.6,1.56,2.16,1.91,1,.62,3.72-.69,4.01.45.5,1.95.71,3.35-.77,4.72-3.68,3.4-6.33,8.94-7.95,10.14"
        style={{ fill: '#f0643a' }}
      />
      <path
        d="m29.55,30.14c-.17-2.93-.81-7.97-3.07-11.53-1.52-2.4-5.05-4-6.83-4.25.64-.23,1.33-.35,2.03-.35,2.77,0,6.59,1.98,8.28,7.56l.19.63c.93,3.04,1.68,5.47-.59,7.94Z"
        style={{ fill: '#f2ede7' }}
      />
      <path
        d="m21.67,14.18c2.71,0,6.46,1.95,8.11,7.43l.19.64c.88,2.85,1.58,5.16-.28,7.46-.21-2.99-.9-7.76-3.07-11.19-1.37-2.16-4.33-3.68-6.26-4.19.42-.1.86-.15,1.31-.15m0-.35c-1.05,0-2.07.25-2.97.76.12-.06.29-.1.5-.1,1.59,0,5.54,1.7,7.13,4.21,2.36,3.71,2.93,9.15,3.07,11.85,2.86-2.82,1.76-5.59.72-9.04-1.57-5.21-5.17-7.68-8.45-7.68h0Z"
        style={{ fill: '#2a2e31' }}
      />
      <path
        d="m32.44,25.24c-.05-1.87-1.01-6.87-4.72-10.53.82.08,1.83.22,2.07.37,2.68,1.66,3.48,6.42,3.55,7.95.01.27,0,.84,0,1.02-.12.15-.51.66-.9,1.19Z"
        style={{ fill: '#f2ede7' }}
      />
      <path
        d="m28.18,14.93c.72.08,1.36.19,1.52.29,2.62,1.62,3.4,6.3,3.47,7.81.01.24,0,.73,0,.96-.11.14-.33.43-.59.77-.18-2.11-1.21-6.46-4.4-9.83m-.94-.44c4.7,4.31,5.15,10.57,5,11.31.54-.75,1.28-1.69,1.28-1.69,0,0,.01-.77,0-1.09-.04-.9-.64-6.24-3.63-8.09-.44-.27-2.64-.43-2.64-.43h0Z"
        style={{ fill: '#2a2e31' }}
      />
      <path
        d="m34.72,22.52c0-.81-.12-2.04-.32-2.71-.33-1.09-1.5-3.16-2.2-4.3.6.16,1.18.34,1.28.41,1.64,1.33,2.43,4.13,2.49,5.34-.07.09-.82.88-1.24,1.26Z"
        style={{ fill: '#f2ede7' }}
      />
      <path
        d="m32.57,15.79c.39.11.71.21.79.26,1.55,1.26,2.32,3.87,2.41,5.1-.15.19-.56.63-.89.97-.03-.79-.15-1.78-.32-2.37-.32-1.04-1.33-2.85-1.99-3.97m-.75-.56c.58.89,2.04,3.39,2.42,4.63.23.75.36,2.28.3,3.03.22-.08,1.6-1.56,1.6-1.64-.05-1.11-.8-4.04-2.55-5.47-.21-.17-1.77-.55-1.77-.55h0Z"
        style={{ fill: '#2a2e31' }}
      />
      <path
        d="m35.4,26.25c.4,2.33-.8,4.82-3.57,6.65-1.18-1.39-2.31-2.87-3.39-3.76-.33-.27-.45-.95.17-1.48,0,0,2.09-1.37,6.79-1.4Z"
        style={{
          fill: '#d94726',
          stroke: '#d94726',
          strokeMiterlimit: 10,
          strokeWidth: 1.16,
        }}
      />
    </>
  </AvatarArtwork>
);
